<div>
  <div class="searchsection">
    <div class="searchinput">
      <input type="search"
        [placeholder]="(searchFolderTemplate ? '_search_from_template_folder_' : '_create_from_template_') | translate"
        #searchBox
        (focusin)="onInputClicked()"
        (keyup.enter)="search(searchBox.value)"
        class="search-input"
        />
      @if (searchString) {
        <div (click)="closeSearch()" class="close-search">
          <ion-icon name="close-circle-outline"></ion-icon>
        </div>
      }
    </div>
    <div (click)="search(searchBox.value)" class="searchicon">
      <ion-icon name="search-outline"></ion-icon>
    </div>
  </div>

  <!-- recently used section-->

  <div>
    @if ( showRecentlyused && recentlyUsedTemplates.length && isInputfieldClicked ) {
      <div class="template-list">
        <div class="recently-used-section">{{'_recently_used_' |translate}}</div>
        <div>
          @for (recentlyUsedTemplate of recentlyUsedTemplates; track recentlyUsedTemplate; let last = $last) {
            <div>
              <div (click)="recentTemplateSelect(recentlyUsedTemplate.id, recentlyUsedTemplate.type)" class="result-list">
                <div style="display: flex">
                  <img
                    (load)="onImageLoad($event)"
                    [src]="imageLoaded ? recentlyUsedTemplate.image : placeholderImageUrl"
                    class="result-img"
                    />
                  <div class="result-content">
                    @if ( recentlyUsedTemplate.type === 'store_special') {
                      <span
                      class="result-title">{{"_store_special_" | translate}}</span>
                    }
                    @if (recentlyUsedTemplate.type === 'news' ) {
                      <span class="result-title">{{"_news_" | translate}}</span>
                    }
                    @if (recentlyUsedTemplate.type === 'offer' ) {
                      <span
                      class="result-title">{{"_offer_" | translate}}</span>
                    }
                    <p class="result-subtitle">{{recentlyUsedTemplate.title}}</p>
                  </div>
                </div>
                <div style="width:24px">
                  <ion-icon name="chevron-forward-outline" class="result-right-icon"></ion-icon>
                </div>
              </div>
              @if (!last) {
                <div class="result-separator"></div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>


  <!--<div *ngIf="loading && isSearchClicked"></div>-->
  @if (isSearchClicked && loading) {
    <div>
      <profi-search-template-skeleton></profi-search-template-skeleton>
    </div>
  }
  <!--<div clickOutside (clickOutside)="hideSearchResult()">-->
  @if (isSearchClicked && resultTemplates.length>0 && !loading) {
    <div class="template-list">
      <div style="border-bottom: 1px solid #C5C5C7">
        <div class="result-title-content">
          <p>{{resultTemplates.length}} {{'_results_' |translate}}</p>
          <ion-icon name="filter-outline" style="font-size: 24px;cursor: pointer" (click)="toggleselectType()"></ion-icon>
        </div>
      </div>
      @if (showOfferOption) {
        <div class="current-section">
          <p class="current-in-view">{{"_currently_in_view_" | translate}}:</p>
          <div class="offer-container">
            <div class="offer-type"
              [class.disabled]="disabledFilter"
              (click)="doesTypeinlcudeStoreSpecial ? toggleTypeSelect('store_special',$event) : null">
              @if (!isStoreSpecialClicked) {
                <ion-icon class="check-icon" name="square-outline"></ion-icon>
              }
              @if (isStoreSpecialClicked ) {
                <ion-icon class="check-icon" name="checkbox"></ion-icon>
              }
              <p class="offer-type-text">{{"_filter_store_special_" | translate}}</p>
            </div>
            <div
              class="offer-type"
              [class.disabled]="disabledFilter"
              (click)="doesTypeincludeNews ? toggleTypeSelect('news',$event) : null">
              @if (!isNewsClicked) {
                <ion-icon class="check-icon" name="square-outline"></ion-icon>
              }
              @if (isNewsClicked) {
                <ion-icon class="check-icon" name="checkbox"></ion-icon>
              }
              <p class="offer-type-text">{{"_filter_news_" | translate}}</p>
            </div>
            <div class="offer-type"
              [class.disabled]="disabledFilter"
              (click)="doesTypeincludeOffer ? toggleTypeSelect('offer',$event): null">
              @if (!isOfferClicked) {
                <ion-icon class="check-icon" name="square-outline"></ion-icon>
              }
              @if (isOfferClicked) {
                <ion-icon class="check-icon" name="checkbox"></ion-icon>
              }
              <p class="offer-type-text">{{"_filter_offer_" | translate}}</p>
            </div>
          </div>
        </div>
      }
      @if (resultTemplates.length === 0 ) {
        <div>
          <p class="empty-data">{{'_no_templates_found_' | translate}}</p>
        </div>
      }
      <!--<div>-->
      <div>
        @if (resultTemplates.length !== 0 && !loading) {
          <div>
            @for (resultTemplate of resultTemplates; track resultTemplate; let last = $last) {
              <div>
                <div (click)="recentTemplateSelect(resultTemplate.id, resultTemplate.type)" class="result-list">
                  <div style="display: flex">
                    <img
                      (load)="onImageLoad($event)"
                      [src]="imageLoaded ? resultTemplate.image : placeholderImageUrl"
                      class="result-img"
                      />
                    <div class="result-content">
                      @if (resultTemplate.type === 'store_special') {
                        <span
                        class="result-title">{{ '_store_special_' |translate }}</span>
                      }
                      @if (resultTemplate.type === 'news' ) {
                        <span class="result-title">{{ "_news_" |translate }}</span>
                      }
                      @if (resultTemplate.type === 'offer' ) {
                        <span class="result-title">{{ '_offer_' | translate }}</span>
                      }
                      <p class="result-subtitle">{{resultTemplate.title}}</p>
                    </div>
                  </div>
                  <div style="width: 24px">
                    <ion-icon name="chevron-forward-outline" class="result-right-icon"></ion-icon>
                  </div>
                </div>
                @if (!last) {
                  <div class="result-separator"></div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  @if ((resultTemplatesPage > templatePage) && resultTemplates.length > 0) {
    <div>
      <div (click)="loadMore($event)" class="loadmoreBtn">
        <p>{{"_load_more_" |translate}}</p>
      </div>
    </div>
  }
  @if (isSearchClicked && resultTemplates.length === 0 && !loading) {
    <div class="template-list">
      <div style="border-bottom: 1px solid #C5C5C7">
        <div class="result-title-content">
          <p>{{resultTemplates.length}} {{'_results_' |translate}}</p>
          <ion-icon name="filter-outline" style="font-size: 24px"></ion-icon>
        </div>
      </div>
      <div>
        <p class="empty-data">{{"_no_templates_found_" |translate}}</p>
      </div>
    </div>
  }
<!--</div>-->

</div>
